import {LanguageProfile} from '../types/shared-types';
import {SupportedLanguages} from '../types/SupportedLanguages';

export const safelyUseLanguageProfile = (lang: SupportedLanguages, langKeys?: LanguageProfile): string | undefined => {
  if (lang === 'en') {
    return langKeys?.en ? langKeys.en : langKeys?.de;
  }

  return langKeys?.de ? langKeys.de : langKeys?.en;
};
